<template>
  <ModalXD>
    <div class="person-container">
      <div class="input-wrapper">
        <h1 class="title">Legg til person</h1>
      </div>
      <div class="input-wrapper">
        <div>
          <label>Posisjon:</label>
          <input type="number" placeholder="0" v-model="person.position" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Navn: </label>
          <input type="text" placeholder="Navn" v-model="person.name" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Tittel: </label>
          <input type="text" placeholder="Tittel" v-model="person.title" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Gruppe: </label>
          <select v-model="person.group">
            <option :value="group" v-for="(group, i) in groups" :key="i">
              {{ group }}
            </option>
          </select>
        </div>
      </div>
      <!-- <div class="input-wrapper">
        <div>
          <label> Tlf: </label>
          <input
            type="text"
            placeholder="Telefon-nummer"
            v-model="person.tlf"
          />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Email: </label>
          <input
            type="text"
            placeholder="Email-adresse"
            v-model="person.email"
          />
        </div>
      </div> -->
      <div class="input-wrapper">
        <div>
          <label> Bildetager: </label>
          <input type="text" placeholder="Trengs bare hvis bildet er tatt profesjonelt" v-model="person.cred" />
        </div>
      </div>
      <div class="input-wrapper" v-if="person.group == 'Andre bidragsytere'">
        <div>
          <label> Beskrivelse: </label>
          <textarea placeholder="Beskrivelse" v-model="person.description"></textarea>
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Bilde: </label>
          <input type="file" ref="installationfile" class="image-selector" accept="image/*"
            @change="handleFileChange" />
        </div>
      </div>
      <div class="input-wrapper">
        <button @click="publishPerson">
          Publiser<span class="material-icons">publish</span>
        </button>
      </div>
    </div>
  </ModalXD>
</template>

<script>
import ModalXD from "@/components/ModalXD.vue";
import { storage } from '@/database/storage'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
export default {
  name: "ModalPerson",
  components: {
    ModalXD,
  },
  data() {
    return {
      userTypes: ["Admin", "Redaktør", "Observatør"],
      groups: ["Styret", "Poesiparkens venner", "Andre bidragsytere"],
      person: {
        file: null,
        uniqid: null,
        userType: null,
        position: 0,
        name: "",
        title: "",
        group: null,
        description: "",
        avatar: null,
        tlf: "",
        email: "",
        cred: null,
      },
    };
  },
  watch: {
    file(newFile) {
      this.imageChanged = !!newFile;
    },
  },
  methods: {
    getCoordinates(e) {
      this.person.position.lat = e.latLng.lat();
      this.person.position.lng = e.latLng.lng();
    },

    handleFileChange(e) {
      this.file = e.target.files[0];
    },

    async publishPerson() {
      try {
        let payload = { ...this.person };

        // Upload avatar if exists
        if (this.file) {
          const fileName = `${Date.now()}_${this.file.name}`;
          const fileRef = storageRef(storage, `people/${fileName}`);
          await uploadBytes(fileRef, this.file);
          const url = await getDownloadURL(fileRef);
          payload.avatar = url;
        }

        // Remove empty cred
        if (payload.cred === "") payload.cred = null;

        await this.$store.dispatch("addPerson", payload);
        this.$emit("close");
        this.$toast.success("Person lagt til!");
      } catch (err) {
        console.error(err);
        this.$toast.error("Kunne ikke lagre personen");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.person-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;

  .input-wrapper {
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    width: 100%;

    * {
      width: 100%;
      margin: 5px;
      margin-right: 15px;
      padding: 0;
    }

    button {
      margin: 0px;
      padding: 20px;
      font-size: 1em;
      background: #2a8355;
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      span {
        margin: 0 5px;
        width: fit-content;
      }
    }
  }
}

p {
  margin: 0;
  padding: 0;
  font-size: 1em;
}

.txt-ara {
  height: 10em;
  white-space: pre-wrap;
}

.custom-file-upload {
  padding: 20px;
  font-size: 1em;
  background: #2a8355;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
